
import React, { useEffect, useState } from 'react';
import { IoMdCreate, IoIosCalendar, IoIosCheckmark, } from "react-icons/io";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { arrayMove } from "@dnd-kit/sortable";

import { Api } from '../../../../services/api';
import RocksTargetCompOne from '../../../../components/Strategic Plan/RocksTargetCompOne';
import CompanyRocksSection from '../../../../components/Strategic Plan/CompanyRocksSection';
import CompanyRocks from '../../../../components/Strategic Plan/CompanyRocks';

function RocksTarget() {

    const [isAdmin, setIsAdmin] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const [editRowId, setEditRowId] = useState(null);

    const [formData, setFormData] = useState({
        futureDate: new Date('December 31, 2026'),
        revenue: [
            {
                description: 'Gross Sale Value',
                value: '10%'
            },
        ],
        profit: [
            {
                description: 'Gross Sale Value',
                value: '10%'
            },
        ],
        measurables: [
            {
                description: 'Gross Sale Value',
                value: '10%'
            },
        ],

    });



    const [rows, setRows] = useState([]);

    // const handleRowOrderChange = (newOrder) => {
    //     // Update the state with the new order
    //     setRows(newOrder); // Assuming you have a state variable for dummyData
    // };


    useEffect(() => {
        fetchData();
        const adminStatus = localStorage.getItem('isAdmin');
        setIsAdmin(adminStatus === 'Y');
    }, []);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(Api.API_BASE_URL + 'business-core/goal/rocks/get', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : '',
                },
            });
            const data = await response.json();
            if (data.result) {
                // Assuming data.result contains the necessary fields

                console.log(data)
                const { future_date, revenue, profit, measurables, lookslike, company_rocks } = data.result;


                // Check if futureDate is valid
                const parsedDate = new Date(future_date);
                const isValidDate = !isNaN(parsedDate.getTime());

                setFormData({
                    futureDate: isValidDate ? parsedDate : new Date(),
                    revenue: revenue || [{ description: '', value: '' }],
                    profit: profit || [{ description: '', value: '' }],
                    measurables: measurables || [{ description: '', value: '' }],
                    lookslike: lookslike || formData.lookslike,
                });
                setRows(company_rocks || []);
            } else {
                setFormData({
                    futureDate: new Date(),
                    revenue: [{ description: '', value: '' }],
                    profit: [{ description: '', value: '' }],
                    measurables: [{ description: '', value: '' }],
                    lookslike: formData.lookslike,
                });
                setRows([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setRows([]);
        }
    };

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (active.id !== over.id) {
            const oldIndex = rows.findIndex((row) => row.id === active.id);
            const newIndex = rows.findIndex((row) => row.id === over.id);
            setRows((prevRows) => arrayMove(prevRows, oldIndex, newIndex));
        }
    };

    const handleStatusChange = (id, newStatus) => {
        setRows((prevRows) =>
            prevRows.map((row) => (row.id === id ? { ...row, status: newStatus } : row))
        );
    };

    const handleTitleChange = (id, newTitle) => {
        setRows((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? { ...row, title: newTitle } : row
            )
        );
    };

    const handleRowOrderChange = (newOrder) => {
        setRows(newOrder);
    };


    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleEditClick = (id) => {
        setIsEditing(true);
        setEditRowId(id); // Set the row id being edited
    };

    const handleSave = async () => {
        setIsEditing(false);
        setEditRowId(null);
        try {
            const token = localStorage.getItem('authToken');
            const payload = {
                futureDate: formData.futureDate,
                revenue: formData.revenue,
                profit: formData.profit,
                measurables: formData.measurables,
                rows: rows,
            };

            const response = await fetch(Api.API_BASE_URL + 'business-core/goal/rocks/save', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : '',
                },
                body: JSON.stringify(payload),
            });

            fetchData();

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

        } catch (error) {
            console.error('Error saving data:', error);
            fetchData();

        }
    };


    const handleDateChange = (date) => {
        setFormData({
            ...formData,
            futureDate: date,
        });
    };



    const handleAddRow = (section) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [section]: [
                ...prevFormData[section],
                { description: '', value: '' },
            ],
        }));
    };

    const handleDeleteRow = (section, index) => {
        setFormData((prevFormData) => {
            const newData = [...prevFormData[section]];
            newData.splice(index, 1);
            return {
                ...prevFormData,
                [section]: newData,
            };
        });
    };




    const handleChange = (section, e, field, index) => {
        const newData = [...formData[section]];
        newData[index][field] = e.target.value;
        setFormData({
            ...formData,
            [section]: newData,
        });
    };


    // Custom input component to include the calendar icon
    const CustomDateInput = ({ value, onClick }) => (
        <div className="custom-date-input">
            <input
                type="text"
                value={value}
                onClick={onClick}
                readOnly
                className="effect-1"
                placeholder="Select a date"
                style={{
                    width: '100%',
                }}
            />
            <IoIosCalendar
                onClick={onClick}
                style={{ fontSize: '20px', position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}
            />
        </div>
    );

    return (
        <div className="box2">
            <div className="box-header">
                <h4 className='subtitle-font'>Q4 Rocks & Targets</h4>
                {isAdmin && (
                    !isEditing ? (
                        <IoMdCreate
                            onClick={handleEdit}
                            style={{
                                fontSize: '20px',
                                cursor: 'pointer',
                            }}
                        />
                    ) : (
                        <IoIosCheckmark
                            onClick={handleSave}
                            style={{
                                fontSize: '40px',
                                cursor: 'pointer',
                            }}
                        />
                    )
                )}

            </div>

            <div className="box-body" style={{ fontFamily: 'Arial, sans-serif' }}>
                <div className="box-title">
                    {isEditing ? (
                        <>
                            <levle style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>Future Date:</levle>
                            <DatePicker
                                selected={formData.futureDate}
                                onChange={handleDateChange}
                                dateFormat="MMMM d, yyyy"
                                customInput={<CustomDateInput />}
                                style={{
                                    display: 'flex',
                                }} />
                        </>
                    ) : (
                        <h4>Future Date: <span className='text-grey'>{formData.futureDate.toLocaleDateString()}</span></h4>
                    )}
                </div>

                <RocksTargetCompOne
                    title="Revenue"
                    data={formData.revenue}
                    onAddRow={() => handleAddRow('revenue')}
                    onDeleteRow={(index) => handleDeleteRow('revenue', index)}
                    onChange={(e, field, index) => handleChange('revenue', e, field, index)}
                    isEditing={isEditing}
                />

                <RocksTargetCompOne
                    title="Profit"
                    data={formData.profit}
                    onAddRow={() => handleAddRow('profit')}
                    onDeleteRow={(index) => handleDeleteRow('profit', index)}
                    onChange={(e, field, index) => handleChange('profit', e, field, index)}
                    isEditing={isEditing}
                />

                <RocksTargetCompOne
                    title="Measurables"
                    data={formData.measurables}
                    onAddRow={() => handleAddRow('measurables')}
                    onDeleteRow={(index) => handleDeleteRow('measurables', index)}
                    onChange={(e, field, index) => handleChange('measurables', e, field, index)}
                    isEditing={isEditing}
                />

                {/* <CompanyRocksSection
                    rows={rows}
                    onTitleChange={handleTitleChange}
                    onDragEnd={handleDragEnd}

                    isEditing={isEditing}
                    editRowId={editRowId}
                    onEditClick={handleEditClick}
                /> */}

                {/* <CompanyRocks
                    rows={rows}
                    onTitleChange={handleTitleChange}
                    onDragEnd={handleDragEnd}
                    onRowOrderChange={handleRowOrderChange}
                    isEditing={isEditing}
                    editRowId={editRowId}
                    onEditClick={handleEditClick}
                /> */}

                <CompanyRocks
                    initialData={rows}
                    onStatusChange={handleStatusChange}
                    onTitleChange={handleTitleChange}
                    onRowOrderChange={handleRowOrderChange}
                />


            </div>
        </div>
    );
}

export default RocksTarget;
